import { gql } from '@apollo/client';

const ADD_AVAILABILITY = gql`
  mutation AddAvailability(
    $availableInPerson: Boolean
    $availableOnline: Boolean
    $defaultTimeAfter: Decimal
    $end: DateTime!
    $isActive: Boolean
    $location: String
    $maxTimeRule: Decimal
    $maxTravelDistance: Decimal
    $maxTravelTime: Decimal
    $start: DateTime!
    $startTimeRule: String
    $travelMode: String
    $userUuid: String
    $addressEntityId: String
    $availableHouseCalls: Boolean
    $availableMyLocation: Boolean
    $travelRangeMethod: String
    $travelBoundary: JSON
    $isTemplate: Boolean = false
    $templateName: String = ""
  ) {
    addAvailability(
      availability: {
        start: $start
        end: $end
        isActive: $isActive
        startTimeRule: $startTimeRule
        travelMode: $travelMode
        userUuid: $userUuid
        maxTravelTime: $maxTravelTime
        maxTravelDistance: $maxTravelDistance
        maxTimeRule: $maxTimeRule
        location: $location
        defaultTimeAfter: $defaultTimeAfter
        availableOnline: $availableOnline
        availableInPerson: $availableInPerson
        addressEntityId: $addressEntityId
        availableHouseCalls: $availableHouseCalls
        availableMyLocation: $availableMyLocation
        travelRangeMethod: $travelRangeMethod
        travelBoundary: $travelBoundary
        isTemplate: $isTemplate
        templateName: $templateName
      }
    ) {
      errors
      success
      availability {
        id
        inPerson: availableInPerson
        online: availableOnline
        start
        end
        isActive
        timeAfter: defaultTimeAfter
        maxTimeRule
        startTimeRule
        locationName: location
        locationAddress {
          uuid
          locationPhotoUrl
          name
          showInDirectory
          thirdPartyAddress
          address {
            addressLine1
            addressLine2
            addressLine3
            attention
            city
            postalCode
            summary
            uuid
            zone
            region {
              name
            }
            coordinates
            isOrg
            category {
              name
            }
          }
        }
        maxTravelDistance
        maxTravelTime
        travelMode
        user {
          username
          profileImageUrl
        }
        maxTravelTimeMins
        travelBoundary
        travelRangeMethod
        houseCalls: availableHouseCalls
        atMyLocation: availableMyLocation
        date
        hostName
        isTemplate
        templateName
      }
    }
  }
`;
const UPDATE_AVAILABILITY = gql`
  mutation UpdateAvailabilityMutation(
    $id: ID!
    $start: DateTime!
    $end: DateTime!
    $isActive: Boolean
    $startTimeRule: String
    $defaultTimeAfter: Decimal
    $maxTimeRule: Decimal
    $maxTravelTime: Decimal
    $maxTravelDistance: Decimal
    $travelMode: String
    $location: String
    $addressEntityId: String
    $availableOnline: Boolean
    $availableInPerson: Boolean
    $availableHouseCalls: Boolean
    $availableMyLocation: Boolean
    $travelRangeMethod: String
    $travelBoundary: JSON = ""
    $isTemplate: Boolean
    $templateName: String
  ) {
    updateAvailability(
      availability: {
        id: $id
        start: $start
        end: $end
        isActive: $isActive
        startTimeRule: $startTimeRule
        defaultTimeAfter: $defaultTimeAfter
        maxTimeRule: $maxTimeRule
        maxTravelTime: $maxTravelTime
        maxTravelDistance: $maxTravelDistance
        travelMode: $travelMode
        location: $location
        addressEntityId: $addressEntityId
        availableOnline: $availableOnline
        availableInPerson: $availableInPerson
        availableHouseCalls: $availableHouseCalls
        availableMyLocation: $availableMyLocation
        travelRangeMethod: $travelRangeMethod
        travelBoundary: $travelBoundary
        isTemplate: $isTemplate
        templateName: $templateName
      }
    ) {
      success
      errors
      availability {
        id
        start
        end
        isActive
        startTimeRule
        timeAfter: defaultTimeAfter
        maxTimeRule
        maxTravelTime
        maxTravelTimeMins
        maxTravelDistance
        travelMode
        travelRangeMethod
        travelBoundary
        isTemplate
        templateName
        locationName: location
        online: availableOnline
        atMyLocation: availableMyLocation
        inPerson: availableInPerson
        houseCalls: availableHouseCalls
        addressId
        date
        hostName
        locationAddress {
          name
          uuid
          thirdPartyAddress
          address {
            addressLine1
            addressLine2
            addressLine3
            city
            region {
              id
              name
              label
            }
            isOrg
            postalCode
            zone
            uuid
            attention
            coordinates
          }
          showInDirectory
        }
      }
    }
  }
`;

const REDEEM_PRODUCT_USER_ADMISSION = gql`
  mutation RedeemProductUserAdmission(
    $host: String!
    $availabilityId: ID!
    $admissionId: ID!
    $eventId: ID!
    $start: DateTime
    $end: DateTime
    $isOnline: Boolean
    $isOffline: Boolean
    $location: String
    $locationAddressId: String
    $description: String
  ) {
    redeemProductUserAdmission(
      admissionId: $admissionId
      availabilityId: $availabilityId
      eventOccurrence: {
        eventId: $eventId
        start: $start
        end: $end
        isOnline: $isOnline
        isOffline: $isOffline
        location: $location
        locationAddressId: $locationAddressId
        description: $description
      }
      host: $host
    ) {
      success
      errors
      admission {
        uuid
        spec
        isRedeemed
        isRevoked
        issuedAt
        productUserOnly
        revokedAt
        redeemedAt
        event {
          id
          title
          duration
          selfSchedule
          category {
            id
            title
            description
          }
        }
        eventOccurrence {
          updatedAt
          timeAfter
          start
          end
          minAttendees
          maxAttendees
          admissionRequired
          locationAddress {
            uuid
            name
            locationPhotoUrl
            address {
              uuid
              attention
              addressLine1
              addressLine2
              addressLine3
              city
              zone
              coordinates
              postalCode
              isOrg
            }
          }
          location
          isScheduled
          isOnline
          isOffline
          id
          expirationDate
          description
          createdAt
          cancelled
          hostedBy {
            name
            attendee {
              firstName
              lastName
              profileImageUrl
            }
            id
            rsvp
          }
          liveCall: callEventOccurrence {
            uuid
            start
            end
            topic
            acceptedInviteCount
            archived
            archivedDate
            cancelledReason
            isCancelled
            rejectedInviteCount
            category {
              id
              title
              description
            }
          }
        }
      }
      liveCallInvitation {
        invitationId
      }
      myAttendance {
        id
        isHost
        isPublic
        name
        rsvp
        createdAt
        updatedAt
      }
    }
  }
`;
const UPDATE_RSVP = gql`
  mutation RSVPAttendance($attendeeId: ID, $rsvp: String!, $id: ID!) {
    rsvpAttendance(
      attendee: { attendeeId: $attendeeId, rsvp: $rsvp, id: $id }
    ) {
      success
      errors
      myAttendance {
        id
        name
        rsvp
        updatedAt
        isPublic
        isHost
        createdAt
        cancellationWindowHours
        attendee {
          personUuid: uuid
          firstName
          lastName
        }
        eventOccurrence {
          updatedAt
          timeAfter
          start
          end
          minAttendees
          maxAttendees
          admissionRequired
          locationAddress {
            uuid
            name
            locationPhotoUrl
            address {
              uuid
              attention
              addressLine1
              addressLine2
              addressLine3
              city
              zone
              coordinates
              postalCode
              isOrg
            }
          }
          location
          isScheduled
          isOnline
          isOffline
          id
          expirationDate
          description
          createdAt
          cancelled
          hostedBy {
            name
            attendee {
              firstName
              lastName
              profileImageUrl
            }
            id
            rsvp
          }
          liveCall: callEventOccurrence {
            uuid
            start
            end
            topic
            acceptedInviteCount
            archived
            archivedDate
            cancelledReason
            isCancelled
            rejectedInviteCount
            category {
              id
              title
              description
            }
          }
          event {
            id
            duration
            title
            selfSchedule
            description
            createdAt
            updatedAt
            category {
              id
              title
              description
            }
          }
        }
      }
    }
  }
`;

const ADD_EVENT_ATTENDANCE = gql`
  mutation AddEventAttendanceMutation(
    $eventAdmissionUuid: String
    $eventOccurrenceId: String!
    $liveCallUuid: String
    $productUserEventAdmissionUuid: String
  ) {
    addEventAttendance(
      eventOccurrenceId: $eventOccurrenceId
      eventAdmissionUuid: $eventAdmissionUuid
      liveCallUuid: $liveCallUuid
      productUserEventAdmissionUuid: $productUserEventAdmissionUuid
    ) {
      success
      errors
      admission {
        uuid
        spec
        isRedeemed
        isRevoked
        issuedAt
        productUserOnly
        revokedAt
        redeemedAt
        event {
          id
          title
          duration
          selfSchedule
          category {
            id
            title
            description
          }
        }
        eventOccurrence {
          updatedAt
          timeAfter
          start
          end
          minAttendees
          maxAttendees
          admissionRequired
          locationAddress {
            uuid
            name
            locationPhotoUrl
            address {
              uuid
              attention
              addressLine1
              addressLine2
              addressLine3
              city
              zone
              coordinates
              postalCode
              isOrg
            }
          }
          location
          isScheduled
          isOnline
          isOffline
          id
          expirationDate
          description
          createdAt
          cancelled
          hostedBy {
            name
            attendee {
              firstName
              lastName
              profileImageUrl
            }
            id
            rsvp
          }
          liveCall: callEventOccurrence {
            uuid
            start
            end
            topic
            acceptedInviteCount
            archived
            archivedDate
            cancelledReason
            isCancelled
            rejectedInviteCount
            category {
              id
              title
              description
            }
          }
        }
        attendee {
          id
          rsvp
          name
          isPublic
          createdAt
          updatedAt
          isHost
          attendee {
            personUuid: uuid
            firstName
            lastName
          }
        }
      }
      myCallInvitation {
        invitationId
        accepted
        acceptedDate
        rejected
        rejectedDate
        sent
        liveCall {
          uuid
        }
      }
    }
  }
`;
const ARRANGE_PRODUCT_USER = gql`
  mutation ArrangeProductUser($productUserId: ID!) {
    arrangeProductUser(productUserId: $productUserId) {
      success
      errors
      productUser {
        uuid
        isActive
        isArchived
        transferStatus
        availableForTransfer
        daysAvailableForTransfer
        transferFrom {
          uuid
        }
        transferredAt
        updatedAt
        createdAt
        product {
          id
          code
          altTitle
          altDescription
          transferRule
          isAvailable
          urlSlug
          accountRequired
          product {
            uuid
            title
            description
          }
        }
        productManagers {
          uuid
          isProductOwner
          manager {
            displayName
            username
            avatar
          }
        }
        content {
          title
          slug
          uuid
          isActive
          description
          isHomeContent
        }
        admissions {
          uuid
          admission {
            uuid
            spec
            isRedeemed
            isRevoked
            issuedAt
            productUserOnly
            revokedAt
            redeemedAt
            event {
              id
              title
              duration
              selfSchedule
              category {
                id
                title
                description
              }
            }
            eventOccurrence {
              updatedAt
              timeAfter
              start
              end
              minAttendees
              maxAttendees
              admissionRequired
              locationAddress {
                uuid
                name
                locationPhotoUrl
                address {
                  uuid
                  attention
                  addressLine1
                  addressLine2
                  addressLine3
                  city
                  zone
                  coordinates
                  postalCode
                  isOrg
                }
              }
              location
              isScheduled
              isOnline
              isOffline
              id
              expirationDate
              description
              createdAt
              cancelled
              hostedBy {
                name
                attendee {
                  firstName
                  lastName
                  profileImageUrl
                }
                id
                rsvp
              }
              liveCall: callEventOccurrence {
                uuid
                start
                end
                topic
                acceptedInviteCount
                archived
                archivedDate
                cancelledReason
                isCancelled
                rejectedInviteCount
                category {
                  id
                  title
                  description
                }
              }
            }
            attendee {
              id
              rsvp
              name
              isPublic
              createdAt
              updatedAt
              isHost
              attendee {
                personUuid: uuid
                firstName
                lastName
              }
            }
          }
        }
        events {
          uuid
          isActive
          eventQty
          ordering
          createdAt
          updatedAt
          event {
            id
            title
            duration
            selfSchedule
            category {
              id
              title
              description
            }
          }
        }
      }
    }
  }
`;
const SCHEDULE_EVENT_OCCURRENCE = gql`
  mutation ScheduleEventOccurrence(
    $eventId: ID!
    $start: DateTime!
    $end: DateTime!
    $admissionRequired: Boolean = true
    $ageRestriction: String = "NONE"
    $isOnline: Boolean!
    $isOffline: Boolean!
    $locationAddressId: String
    $minAttendees: Int!
    $maxAttendees: Int!
    $onlineLayoutPolicy: String
    $cancelled: Boolean = false
    $timeAfter: Decimal!
    $expirationDate: Date!
    $isScheduled: Boolean = true
    $location: String
    $timeBefore: Decimal!
    $description: String!
    $invitees: [EventOccurrenceInvitationInputType!] = []
    $resourceBookings: [ResourceBookingInputType!] = []
    $hosts: [String!]
  ) {
    scheduleEventOccurrence(
      eventOccurrence: {
        eventId: $eventId
        start: $start
        end: $end
        admissionRequired: $admissionRequired
        ageRestriction: $ageRestriction
        isOnline: $isOnline
        isOffline: $isOffline
        locationAddressId: $locationAddressId
        minAttendees: $minAttendees
        maxAttendees: $maxAttendees
        onlineLayoutPolicy: $onlineLayoutPolicy
        cancelled: $cancelled
        timeAfter: $timeAfter
        expirationDate: $expirationDate
        isScheduled: $isScheduled
        location: $location
        timeBefore: $timeBefore
        description: $description
        hosts: $hosts
      }
      invitees: $invitees
      resourceBookings: $resourceBookings
    ) {
      errors
      success
      eventOccurrence {
        id
        updatedAt
        timeAfter
        start
        end
        minAttendees
        maxAttendees
        admissionRequired
        ageRestriction
        event {
          id
          title
          description
          duration
          category {
            title
          }
        }
        locationAddress {
          uuid
          name
          locationPhotoUrl
          address {
            uuid
            attention
            addressLine1
            addressLine2
            addressLine3
            city
            zone
            coordinates
            postalCode
            isOrg
          }
        }
        location
        isScheduled
        isOnline
        isOffline
        expirationDate
        description
        createdAt
        cancelled
        hostedBy {
          name
          attendee {
            firstName
            lastName
            profileImageUrl
          }
          id
          rsvp
        }
        liveCall: callEventOccurrence {
          uuid
          start
          end
          topic
          acceptedInviteCount
          archived
          archivedDate
          cancelledReason
          isCancelled
          rejectedInviteCount
          layoutPolicy
          category {
            id
            title
            description
          }
        }
        resourceBookings {
          id
          start
          end
          setupTime
          teardownTime
          isConfirmed
          note
          resource {
            id
            name
            description
            category {
              id
              name
              description
            }
          }
        }
      }
      eventAttendees {
        id
        rsvp
        name
        isPublic
        createdAt
        updatedAt
        isHost
        attendee {
          personUuid: uuid
          firstName
          lastName
        }
      }
      myAttendance {
        id
        name
        isHost
        rsvp
        isPublic
        createdAt
        updatedAt
        attendeeAdmission {
          uuid
          isRedeemed
          isRevoked
          issuedAt
          productUserOnly
          redeemedAt
          revokedAt
          spec
          expirationDate
        }
      }
    }
  }
`;

const UPDATE_EVENT_OCCURRENCE = gql`
  mutation UpdateEventOccurrence(
    $eventId: ID!
    $start: DateTime!
    $end: DateTime!
    $admissionRequired: Boolean = true
    $ageRestriction: String = "NONE"
    $isOnline: Boolean!
    $isOffline: Boolean!
    $locationAddressId: String
    $minAttendees: Int!
    $maxAttendees: Int!
    $cancelled: Boolean = false
    $timeAfter: Decimal!
    $expirationDate: Date!
    $isScheduled: Boolean = true
    $location: String
    $timeBefore: Decimal!
    $description: String!
    $invitees: [EventOccurrenceInvitationInputType!] = []
    $resourceBookings: [ResourceBookingInputType!] = []
    $hosts: [String!]
    $onlineLayoutPolicy: String
    $id: ID!
  ) {
    updateEventOccurrence(
      eventOccurrence: {
        eventId: $eventId
        start: $start
        end: $end
        admissionRequired: $admissionRequired
        ageRestriction: $ageRestriction
        isOnline: $isOnline
        isOffline: $isOffline
        locationAddressId: $locationAddressId
        minAttendees: $minAttendees
        maxAttendees: $maxAttendees
        cancelled: $cancelled
        timeAfter: $timeAfter
        expirationDate: $expirationDate
        isScheduled: $isScheduled
        location: $location
        timeBefore: $timeBefore
        description: $description
        hosts: $hosts
        onlineLayoutPolicy: $onlineLayoutPolicy
        id: $id
      }
      invitees: $invitees
      resourceBookings: $resourceBookings
    ) {
      errors
      success
      eventOccurrence {
        id
        updatedAt
        timeAfter
        start
        end
        minAttendees
        maxAttendees
        admissionRequired
        ageRestriction
        event {
          id
          title
          description
          duration
          category {
            title
          }
        }
        locationAddress {
          uuid
          name
          locationPhotoUrl
          address {
            uuid
            attention
            addressLine1
            addressLine2
            addressLine3
            city
            zone
            coordinates
            postalCode
            isOrg
          }
        }
        location
        isScheduled
        isOnline
        isOffline
        expirationDate
        description
        createdAt
        cancelled
        hostedBy {
          name
          attendee {
            firstName
            lastName
            profileImageUrl
          }
          id
          rsvp
        }
        liveCall: callEventOccurrence {
          uuid
          start
          end
          topic
          acceptedInviteCount
          archived
          archivedDate
          cancelledReason
          isCancelled
          rejectedInviteCount
          layoutPolicy
          category {
            id
            title
            description
          }
        }
        resourceBookings {
          id
          start
          end
          setupTime
          teardownTime
          isConfirmed
          note
          resource {
            id
            name
            description
            category {
              id
              name
              description
            }
          }
        }
      }
      eventAttendees {
        id
        rsvp
        name
        isPublic
        createdAt
        updatedAt
        isHost
        attendee {
          personUuid: uuid
          firstName
          lastName
        }
      }
      myAttendance {
        id
        name
        isHost
        rsvp
        isPublic
        createdAt
        updatedAt
        attendeeAdmission {
          uuid
          isRedeemed
          isRevoked
          issuedAt
          productUserOnly
          redeemedAt
          revokedAt
          spec
          expirationDate
        }
      }
    }
  }
`;

const CANCEL_EVENT_OCCURRENCE = gql`
  mutation CancelEventOccurrence($eventOccurrenceId: ID!, $reason: String) {
    cancelEventOccurrence(
      eventOccurrenceId: $eventOccurrenceId
      reason: $reason
    ) {
      success
      errors
      eventOccurrence {
        id
        updatedAt
        timeAfter
        start
        end
        minAttendees
        maxAttendees
        admissionRequired
        event {
          id
          title
          description
          duration
          category {
            title
          }
        }
        locationAddress {
          uuid
          name
          locationPhotoUrl
          address {
            uuid
            attention
            addressLine1
            addressLine2
            addressLine3
            city
            zone
            coordinates
            postalCode
            isOrg
          }
        }
        location
        isScheduled
        isOnline
        isOffline
        expirationDate
        description
        createdAt
        cancelled
        hostedBy {
          name
          attendee {
            firstName
            lastName
            profileImageUrl
          }
          id
          rsvp
        }
        liveCall: callEventOccurrence {
          uuid
          start
          end
          topic
          acceptedInviteCount
          archived
          archivedDate
          cancelledReason
          isCancelled
          rejectedInviteCount
          layoutPolicy
          category {
            id
            title
            description
          }
        }
        resourceBookings {
          id
          start
          end
          setupTime
          teardownTime
          isConfirmed
          note
          resource {
            id
            name
            description
            category {
              id
              name
              description
            }
          }
        }
      }
      eventAttendees {
        id
        rsvp
        name
        isPublic
        createdAt
        updatedAt
        isHost
        attendee {
          personUuid: uuid
          firstName
          lastName
        }
      }
      myAttendance {
        id
        name
        isHost
        rsvp
        isPublic
        createdAt
        updatedAt
        attendeeAdmission {
          uuid
          isRedeemed
          isRevoked
          issuedAt
          productUserOnly
          redeemedAt
          revokedAt
          spec
          expirationDate
        }
      }
    }
  }
`;
const RSVP_EVENT_OCCURRENCE_INVITATION = gql`
  mutation RsvpEventOccurrenceInvitationMutation(
    $attendOnline: Boolean!
    $invitationUuid: ID!
    $name: String = ""
    $rsvp: String!
  ) {
    rsvpEventOccurrenceInvitation(
      attendOnline: $attendOnline
      invitationUuid: $invitationUuid
      rsvp: $rsvp
      name: $name
    ) {
      success
      errors
      myEventOccurrenceInvitation {
        uuid
        isActive
        issuedAt
        isExclusive
        expirationDate
        deactivationDate
        rsvp
        message
        inviter {
          id
          displayName
          username
        }
        invitee {
          fullName
          uuid
          nickname
        }
        eventOccurrence {
          id
          description
          start
          end
          location
          admissionRequired
          isScheduled
          isOnline
          isOffline
          updatedAt
          timeBefore
          timeAfter
          expirationDate
          createdAt
          cancelled
          event {
            id
            title
            description
            duration
            selfSchedule
            updatedAt
            category {
              id
              title
              description
            }
          }
        }
      }
      myCallInvitation {
        invitationId
        sent
        accepted
        rejected
        acceptedDate
        rejectedDate
        liveCall {
          uuid
          topic
          start
          end
          isCancelled
          cancelledReason
          acceptedInviteCount
          rejectedInviteCount
          archived
          archivedDate
          eventOccurrence {
            id
            start
            end
            description
            location
            isOnline
            isOffline
            isScheduled
            maxAttendees
            minAttendees
            timeAfter
            timeBefore
            updatedAt
            expirationDate
            createdAt
            cancelled
            admissionRequired
            locationAddress {
              uuid
              name
            }
          }
          host {
            username
            avatar
            displayName
            preferNickname
            id
          }
        }
      }
      admission {
        uuid
        spec
        isRedeemed
        isRevoked
        issuedAt
        productUserOnly
        revokedAt
        redeemedAt
        event {
          id
          title
          duration
          selfSchedule
          category {
            id
            title
            description
          }
        }
        eventOccurrence {
          updatedAt
          timeAfter
          start
          end
          minAttendees
          maxAttendees
          admissionRequired
          locationAddress {
            uuid
            name
            address {
              uuid
              attention
              addressLine1
              addressLine2
              addressLine3
              city
              zone
              coordinates
              postalCode
              isOrg
            }
          }
          location
          isScheduled
          isOnline
          isOffline
          id
          expirationDate
          description
          createdAt
          cancelled
          hostedBy {
            id
            name
            attendee {
              personUuid: uuid
              firstName
              lastName
            }
            rsvp
          }
          liveCall: callEventOccurrence {
            uuid
            start
            end
            topic
            acceptedInviteCount
            archived
            archivedDate
            cancelledReason
            isCancelled
            rejectedInviteCount
            layoutPolicy
            category {
              id
              title
              description
            }
          }
        }
        attendee {
          id
          rsvp
          name
          isPublic
          createdAt
          updatedAt
          isHost
          attendee {
            personUuid: uuid
            firstName
            lastName
          }
        }
      }
      myAttendance {
        id
        name
        rsvp
        isHost
        isPublic
        updatedAt
        createdAt
        attendee {
          personUuid: uuid
          firstName
          lastName
        }
        eventOccurrence {
          id
          updatedAt
          timeAfter
          start
          end
          minAttendees
          maxAttendees
          admissionRequired
          location
          isScheduled
          isOnline
          isOffline
          expirationDate
          description
          createdAt
          cancelled
          hostedBy {
            name
            id
            rsvp
          }
          locationAddress {
            uuid
            name
            address {
              uuid
              attention
              addressLine1
              addressLine2
              addressLine3
              city
              zone
              coordinates
              postalCode
              isOrg
            }
          }
          liveCall: callEventOccurrence {
            uuid
            start
            end
            topic
            acceptedInviteCount
            archived
            archivedDate
            cancelledReason
            isCancelled
            rejectedInviteCount
            category {
              id
              title
              description
            }
          }
          resourceBookings {
            id
            start
            end
            setupTime
            teardownTime
            isConfirmed
            note
            resource {
              id
              name
              description
              category {
                id
                name
                description
              }
            }
          }
          event {
            id
            title
            description
          }
        }
      }
    }
  }
`;

const GENERATE_ICAL_TOKEN = gql`
  mutation GenerateCalendarToken {
    regenerateCalendarToken {
      errors
      success
      calendarToken {
        url
        uuid
      }
    }
  }
`;

export {
  ADD_AVAILABILITY,
  UPDATE_AVAILABILITY,
  REDEEM_PRODUCT_USER_ADMISSION,
  UPDATE_RSVP,
  ADD_EVENT_ATTENDANCE,
  ARRANGE_PRODUCT_USER,
  SCHEDULE_EVENT_OCCURRENCE,
  UPDATE_EVENT_OCCURRENCE,
  CANCEL_EVENT_OCCURRENCE,
  RSVP_EVENT_OCCURRENCE_INVITATION,
  GENERATE_ICAL_TOKEN,
};
